import { DISPOSITION_COLORS } from './constants';

export const getCurrentColors = (label?: string) => {
  const s = label?.toLowerCase() ?? '';
  if (s.includes('callback'))
    return { sheet: DISPOSITION_COLORS.CALLBACK.sheet, badge: DISPOSITION_COLORS.CALLBACK.badge };
  if (s.includes('problem') || s.includes('return') || s.includes('reject'))
    return { sheet: DISPOSITION_COLORS.PROBLEM.sheet, badge: DISPOSITION_COLORS.PROBLEM.badge };
  if (s.includes('exception') || s.includes('hold') || s.includes('review'))
    return { sheet: DISPOSITION_COLORS.EXCEPTION.sheet, badge: DISPOSITION_COLORS.EXCEPTION.badge };
  return {
    sheet: 'bg-blue-50 border-blue-200',
    badge: 'bg-blue-100 text-blue-700 border-blue-200',
  };
};
